import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8cdd12a0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./list-collaborator.css?vue&type=style&index=0&id=8cdd12a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdd12a0",
  null
  
)

export default component.exports